import React from "react";
import { useTheme, useMediaQuery, Typography } from "@mui/material";

import { AreaChart, Area, ResponsiveContainer } from 'recharts';

import { colord } from "colord";

import { SparklineSettingsStateType, defaultSettings } from './SparklineSettings';
import { Stack } from "@mui/system";
import ISONumber from "components/formatting/ISONumber";
import TitleCase from "components/formatting/TitleCase";

interface SparklinePreviewProps {
  /**
   * State object represented by series of key value pairs,
   * where the key is a string which represents the title of the
   * updatable settings option.
   */
  settingsState: SparklineSettingsStateType | {};
}

export default function SparklinePreview(props: SparklinePreviewProps) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const currentState = {...defaultSettings, ...props.settingsState};
  const dummyData = [
    { value: 12214 },
    { value: 31172 },
    { value: 25873 },
    { value: 45440 }
  ];

  return (
    <Stack sx={{
      width: isSmallScreen ? '100%' : '50%'
    }}>
      {currentState.widgetTitle !== 'none' &&
        <Typography
          sx={{ fontSize: "1.2rem", textAlign: `${currentState.widgetTitleAlignment}` }}
          variant="subtitle2">
          <TitleCase text={currentState.widgetTitle ?? ""} />
        </Typography>}
      {(currentState.showPercentChange || currentState.showTotal) &&
        <Stack
          direction="row"
          sx={{
            paddingLeft: currentState.showTotal ? 2 : 0,
            alignItems: "center"
          }}>
          {currentState.showTotal &&
            <Typography variant="h1" >
              <ISONumber number={12345} sx={{ fontSize: "2rem", fontWeight: "bold", paddingLeft: 1, textAlign: "left" }} />
            </Typography>
          }
          {currentState.showPercentChange &&
            <Typography variant="body1" sx={{ color: theme.colors.namedColors.positive, fontSize: "1.2rem", textAlign: "left", paddingLeft: currentState.showTotal ? 1 : 0 }}>
              +67%
            </Typography>
          }
        </Stack>
      }
      <ResponsiveContainer aspect={(4/3)} width="100%">
        <AreaChart
          data={dummyData}
          margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
        >
          <Area
            type="monotone"
            dot={currentState.showDots
              ? {
                stroke: currentState.lineColor ?? theme.palette.primary.main,
                strokeWidth: currentState.dotSize,
                fill: currentState.lineColor ?? theme.colors.primary.lighter,
                r: 3,
                opacity: 1
                }
              : false}
            dataKey="value"
            stroke={currentState.lineColor ?? theme.palette.primary.main}
            strokeWidth="2"
            fill={currentState.lineColor
              ? colord(currentState.lineColor).alpha(0.1).toRgbString()
              : colord(theme.palette.primary.main).alpha(0.1).toRgbString()} />
        </AreaChart>
      </ResponsiveContainer>
    </Stack>
  );
}